export enum ShowFieldsOption {
  Default = 'Default',
  RequiredForPhase = 'RequiredForPhase',
  RequiredToPromote = 'RequiredToPromote',
  All = 'All'
}
